import { useEffect, useRef, useState } from "react";

const ProgressBar = ({ title, value, duration = 1500 }) => {
    const barRef = useRef(null);
    const [animate, setAnimate] = useState(false);
    const [count, setCount] = useState(0);

    // Trigger animation when the component enters the viewport
    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    setAnimate(true);
                    observer.disconnect();
                }
            },
            { threshold: 0.2 } 
        );

        if (barRef.current) observer.observe(barRef.current);
        return () => observer.disconnect();
    }, []);

    // Smooth number counting logic
    useEffect(() => {
        if (!animate) return;

        let startTimestamp = null;
        const step = (timestamp) => {
            if (!startTimestamp) startTimestamp = timestamp;
            const progress = Math.min((timestamp - startTimestamp) / duration, 1);
            setCount(Math.floor(progress * value));
            if (progress < 1) {
                window.requestAnimationFrame(step);
            }
        };
        window.requestAnimationFrame(step);
    }, [animate, value, duration]);

    return (
        <div className="progress-item-container mb-4" ref={barRef}>
            <div className="progress-label">
                <span className="title-text">{title}</span>
            </div>

            <div className="progress-wrapper">
                <div
                    className={`progress-fill ${animate ? "animate" : ""}`}
                    style={{ "--target-width": `${value}%` }}
                >
                    {/* The floating bubble with the small connector stem */}
                    <div className="percentage-circle">
                        {count}%
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ProgressBar;